import React from 'react'
import {
    BackButton,
    Bloc,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue23() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quelle est la situation professionnelle du second emprunteur?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={70} time={2} />
            </div>

            <div className="Container">
                {/* Si emploi non salarié */}
                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isEqualTo
                    targetDataValueCompare="NS"
                >
                    {/* Si bilan insufisant  */}
                    <Conditionnal
                        linked_data_id="emprunteurs_emploi_bilan_2"
                        isEqualTo
                        targetDataValueCompare="INSUFFISANT"
                    >
                        <br />
                        <br />
                        <br />
                        {/* <Bloc nbcolumn={1} simpleDoubleWord text1="Nombres de bilan insufisant" text2="Votre nombre de bilan est insufisant pour le salaire issu de votre activité soit pris en compte."/>*/}
                    </Conditionnal>
                    {/* Si bilan sufisant on affiche  */}
                    <Conditionnal
                        linked_data_id="emprunteurs_emploi_bilan_2"
                        isNotEqualTo
                        targetDataValueCompare="INSUFFISANT"
                    >
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_2"
                            isEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <BlocIntField
                                key="key102"
                                nbcolumn={1}
                                linked_data_id="emprunteurs_salaire_net_mensuel_2"
                                symbole=" €"
                                label="Revenu moyen Net mensuel sur les 2 dernières années"
                                placeholder="Ex : 2 100 € / mois"
                            />
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_2"
                            isNotEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <BlocIntField
                                key="key102"
                                nbcolumn={1}
                                linked_data_id="emprunteurs_salaire_net_mensuel_2"
                                symbole=" €"
                                label="Revenu moyen Net mensuel sur les 3 dernières années"
                                placeholder="Ex : 2 100 € / mois"
                            />
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                {/* Si emploi est salarié */}
                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isNotEqualTo
                    targetDataValueCompare="NS"
                >
                    <BlocIntField
                        key="key206"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_salaire_net_mensuel_2"
                        symbole=" €"
                        label="Salaire net mensuel du second emprunteur)"
                        placeholder="Ex : 2 100 € / mois"
                        infobulle="Indiquez votre salaire net avant impôt. Vous le trouverez sur votre fiche de paie sous la mention « net à payer avant impôt sur le revenu »."
                    />
                    <Bloc
                        key="key207"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_2"
                        linked_data_value={12}
                        nbcolumn={4}
                        gauche
                        simpleDoubleWord
                        text1="12"
                        text2="mois"
                        height={100}
                    />
                    <Bloc
                        key="key208"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_2"
                        linked_data_value={13}
                        nbcolumn={4}
                        milieu
                        simpleDoubleWord
                        text1="13"
                        text2="mois"
                        height={100}
                    />
                    <Bloc
                        key="key209"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_2"
                        linked_data_value={14}
                        nbcolumn={4}
                        milieu
                        simpleDoubleWord
                        text1="14"
                        text2="mois"
                        height={100}
                    />
                    <Bloc
                        key="key210"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_2"
                        linked_data_value={15}
                        nbcolumn={4}
                        droit
                        simpleDoubleWord
                        text1="15"
                        text2="mois"
                        height={100}
                    />
                    <BlocIntField
                        key="key211"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_primes_2"
                        symbole=" €"
                        label="Primes annuelles nettes hors intéressement et participation"
                        placeholder="Ex : 2 100 € sur l'année"
                        infobulle="Intégrer les primes récurrentes, traitement retraite, BIC ou BNC"
                    />
                </Conditionnal>
            </div>

            <Conditionnal
                linked_data_id="emprunteurs_salaire_net_mensuel_2"
                isNotEmpty
            >
                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Suivant" targetView={12} />{' '}
                </div>
            </Conditionnal>
            <Conditionnal
                linked_data_id="emprunteurs_salaire_net_mensuel_2"
                isEmpty
            >
                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_2"
                    isEqualTo
                    targetDataValueCompare="NS"
                >
                    <Conditionnal
                        linked_data_id="emprunteurs_emploi_bilan_2"
                        isEqualTo
                        targetDataValueCompare="INSUFFISANT"
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={12} />{' '}
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
